// extracted by mini-css-extract-plugin
export var card = "_72-0";
export var expandedCard = "_72-2";
export var paginated = "_72-1";